'use client';
import { Button } from '@/shared/components';
import React, { useEffect, useState } from 'react';
import { EmailPopUp } from './email-popup';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { useProductStore } from '../product-store';
import { useCartStore } from '../cart-store';
import { useAppStore } from '@/store/app-store';

export const EmailPrint = () => {
  const [showPopUp, setShowPopUp] = useState<boolean>(false);
  const { t } = useLang(NAMESPACE.cart);
  const { products } = useProductStore();
  const { isAnonymous } = useAppStore();
  const { availabilityByCatalogNumber } = useCartStore();
  const [disabled, setDisabled] = useState<boolean>(false);

  useEffect(() => {
    const hasProducts = products.length > 0;
    const isEveryProductAvailable = products.every((product) =>
      availabilityByCatalogNumber.hasOwnProperty(product.catalogNumber)
    );
    if (isAnonymous) {
      setDisabled(!hasProducts);
    } else {
      setDisabled(!hasProducts || !isEveryProductAvailable);
    }
  }, [products, availabilityByCatalogNumber]);

  const sendEmail = () => {
    setShowPopUp(true);
  };
  const onPrint = () => {
    window.print();
  };

  return (
    <div className="mt-8 mb-5 lg:mt-0 lg:mb-0 lg:row-start-2 :mt-0 md:mb-0 md:row-start-2  sm:mt-0 sm:mb-0 sm:row-start-2">
      <div className="md:mb-2 sm:mb-2 flex md:flex-col sm:flex-col justify-between lg:justify-end lg:gap-x-2 sm:justify-start sm:gap-x-2 md:justify-end md:gap-x-2 items-center sm:items-baseline print:hidden">
        <Button
          type="link"
          className="p-0 text-left flex items-center disabled:bg-transparent disabled:border-none disabled:text-[#A5A5AE]"
          onClick={sendEmail}
          disabled={disabled}
        >
          <i className="icon-24-email-default-bold" />
          <span className="text-sm font-normal">{t('email.shopping.cart')}</span>
        </Button>
        <span className="text-gray-500 mobile:hidden sm:hidden md:hidden">|</span>
        <Button
          type="link"
          className="p-0 text-left flex items-center mobile:hidden disabled:bg-transparent disabled:border-none disabled:text-[#A5A5AE]"
          onClick={onPrint}
          disabled={disabled}
        >
          <i className="icon-24-print-bold" />
          <span className="text-sm font-normal">{t('print.shopping.cart')}</span>
        </Button>
      </div>
      <EmailPopUp
        isOpen={showPopUp}
        onClose={() => {
          setShowPopUp(false);
        }}
      />
    </div>
  );
};
